module.exports = {"530115001":"昆阳街道","530115002":"宝峰街道","530115003":"晋城街道","530115101":"二街镇","530115102":"上蒜镇","530115103":"六街镇","530115200":"双河彝族乡","530115201":"夕阳彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530115.json
// module id = 2678
// module chunks = 0